// extracted by mini-css-extract-plugin
export var desktop = "lpCompetitorQuoteGlow-module--desktop--1ef51";
export var mobile = "lpCompetitorQuoteGlow-module--mobile--d87c1";